import React from 'react';

import Image from 'next/image';

import useMediaQuery from '../../../hooks/useMediaQuery';
import { EVENT_ATTRIBUTE, EVENT_NAME, useMoengageEventTracker } from '../../../hooks/useMoengage';

import { javaApi } from '../../../utils/AxiosInstance';

import styles from './HeaderBottomBar.module.scss';

const bottomBarHeightProperty = '--bottom-bar-height';

function HeaderBottomBar({ show }) {
  const trackMoengageEvent = useMoengageEventTracker();

  const isMatching = useMediaQuery('(max-width: 767px)');
  const [categories, setCategories] = React.useState([]);

  React.useEffect(() => {
    if (!show) {
      document.body.style.removeProperty(bottomBarHeightProperty);
    }
  }, [show]);

  React.useEffect(() => {
    const bottomBarHeight = document.body.style.getPropertyValue(bottomBarHeightProperty);
    if (bottomBarHeight && isMatching) {
      document.body.style.removeProperty(bottomBarHeightProperty);
    }
  }, [isMatching]);

  const toggleHeaderBottomBarEvent = React.useCallback(() => {
    const bottomBarHeight = document.body.style.getPropertyValue(bottomBarHeightProperty);
    if (bottomBarHeight) {
      document.body.style.removeProperty(bottomBarHeightProperty);
    } else {
      document.body.style.setProperty(bottomBarHeightProperty, '4.125rem');
    }
  }, []);

  React.useEffect(() => {
    javaApi
      .get('/common-ws/api/v2/getExamPreferenceCategory', { params: { mode: 0 } })
      .then((res) => setCategories(res.data.data))
      .catch(() => setCategories([]));

    // Event Listner
    window.addEventListener('toggleHeaderBottomBar', toggleHeaderBottomBarEvent);

    return () => window.removeEventListener('toggleHeaderBottomBar', toggleHeaderBottomBarEvent);
  }, [toggleHeaderBottomBarEvent]);

  const handleItemClick = (category) => () => {
    const selectGoalItemEvent = new CustomEvent('selectGoalItem', { detail: category });
    window.dispatchEvent(selectGoalItemEvent);
    document.body.style.removeProperty(bottomBarHeightProperty);
    document
      .getElementById('popular-online-courses')
      .scrollIntoView({ behavior: 'smooth', block: 'center' });

    trackMoengageEvent(EVENT_NAME.HOMEPAGE_ALL_COURSE_CLICKED, {
      [EVENT_ATTRIBUTE.GOAL]: category.title,
    });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <ul className={styles.categoriesMenu}>
          {categories.map((category) => (
            <li key={category.id}>
              <button type="button" className={styles.menuItem} onClick={handleItemClick(category)}>
                <Image src={category.image} alt={category.title} height={24} width={24} />
                <span>{category.title}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default HeaderBottomBar;
